/**
 * Default HTTP Headers Configuration
 * Centralized header configuration for API clients
 */

export const defaultHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

/**
 * Get headers with optional additional headers
 * @param additionalHeaders - Optional additional headers to merge
 * @returns Headers object
 */
export const getHeaders = (additionalHeaders?: Record<string, string>) => {
  return {
    ...defaultHeaders,
    ...additionalHeaders,
  };
};
